// NERRA: Corner Quick Add — works even if a link overlay steals the click target
(function () {
  function pointInRect(x, y, r) {
    return x >= r.left && x <= r.right && y >= r.top && y <= r.bottom;
  }

  function findCornerButtonAtPoint(x, y) {
    // Find the corner QA button whose bounding box contains this point
    const buttons = document.querySelectorAll(".nerra-corner-qa[data-nerra-corner-qa]");
    for (const btn of buttons) {
      const r = btn.getBoundingClientRect();
      if (r.width && r.height && pointInRect(x, y, r)) return btn;
    }
    return null;
  }

  function triggerQuickAddForButton(btn) {
    const card = btn.closest(".card-wrapper, .card");
    if (!card) return;

    // Multi-variant: open QuickAdd modal (your "first" quick-add__submit block)
    const modalTrigger = card.querySelector(
      'modal-opener[data-modal^="#QuickAdd-"] button.quick-add__submit'
    );
    if (modalTrigger) {
      modalTrigger.click();
      return;
    }

    // Single-variant: submit product-form (your "second" quick-add__submit block)
    const addTrigger = card.querySelector(
      'product-form button.quick-add__submit[name="add"]'
    );
    if (addTrigger) {
      addTrigger.click();
      return;
    }

    console.warn("NERRA: No Quick Add trigger found in this card.");
  }

  function handler(e) {
    // use client coords to detect clicks on the visible corner icon area
    const x = e.clientX;
    const y = e.clientY;
    const btn = findCornerButtonAtPoint(x, y);

    if (!btn) return;

    // ✅ Hard stop navigation / delegated click
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    triggerQuickAddForButton(btn);
  }

  // Capture early, even if overlays steal target
  document.addEventListener("pointerdown", handler, true);
  document.addEventListener("click", handler, true);
})();

